export const Bio = {
    name: "Pershotam Chouhan",
    roles: [
     "Software Developer.",
     "MERN Stack Developer.",
     "Frontend Developer.",
     "Backend Developer.",
     "Problem Solver.",
],   
    description: "Aspiring software developer with strong programming skills, eager to learn from experienced professionals and contribute to impactful projects while delivering value to the organization.",
    github: "https://github.com/pershotamkumar",
    resume: "https://drive.google.com/file/d/1fQqmyeJEGFSXFeuRcVHpR1gdrvfC94dJ/view?usp=sharing",
    linkedin: "https://www.linkedin.com/in/pershotam-kumar-6679a5295/",
    twitter: "https://x.com/pershotamkumar1?t=Qxc66HsvftwVe2F0oASzGg&s=09",
    insta: "https://www.instagram.com/pershotam_1/",
    facebook: "https://www.facebook.com/share/175QyXnRBb/",
};
  
export const skills = [
    {
      title: "Programming & Core Skills",
      skills: [
        {
          name: "C",
          image: "C-logo.png",
        },
        {
          name: "Java",
          image: "java-logo.svg",
        },
       {
        name:"OOP",
        image:"oop.png"
       },
       {
        name:"Data Structures & Algorithms (DSA)",
        image:"dsa.png"
       },
        {
        name:"Operating Systems (OS)",
        image:"os.png"
       },
      ],
    },
    {
      title: "Frontend",
      skills: [
        {
          name: "HTML",
          image: "html5-logo.png",
        },
        {
          name: "CSS",
          image:
            "CSS3-logo.png",
        },
        {
          name: "Bootstrap",
          image:
            "bootstrap-logo.png",
        },
        {
          name: "JavaScript",
          image:
            "JavaScript-logo.png",
        },
        {
          name: "React Js",
          image:
            "react-logo.png",
        },
        {
          name: "Tailwind CSS",
          image:
            "tailwind-logo.png",
        },
      ],
    },
    {
  title: "Backend",
  skills: [
    {
      name: "Node.js",
      image: "nodejs-logo.svg",
    },
    {
      name: "Express.js",
      image: "Expressjs.png",
    },
    {
      name: "MongoDB",
      image: "mongoDB-logo.png",
    },
     {
          name: "SQL",
          image: "sql-logo.png",
        },
    {
      name: "RESTful APIs",
      image: "apilogo.png",
    },
    { name: "Firebase", image: "firebase.png" },
  ],
},

    {
      title: "Tools & Platform",
      skills: [
        {
          name: "Git",
          image:"gitlogo.png",
        },
        {
          name: "GitHub",
          image:
            "GitHub-logo.png",
        },
        {
          name: "VS Code",
          image:
            "vscode-logo.png",
        },
        {
          name:"Postman (API Testing)",
          image:"postman.png"
        }
      ],
    },
];
  
export const experiences = [
    {
      // id: 0,
      // img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/flipr.jpeg?alt=media&token=1d72532a-45eb-4c1a-a81a-c9bed9fec543",
      // role: "DevOps & Fullstack Engineering Intern",
      // company: "Flipr Inovations Pvt. Ltd.",
      // date: "Aug 2023 - July 2023",
      // desc: "Working on Flipr Platforms, managing DevOps, and streamlining the process with automation.",
      // skills: [
      //   "Docker",
      //   "Terraform",
      //   "AWS",
      //   "EC2",
      //   "Portainer",
      //   "Nginx",
      //   "JavaScript",
      //   "TypeScript",
      //   "Node Js",
      //   " Next Js",
      // ],
      // doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
    },
];
  
export const education = [
  {
    id: 0,
    img: "smiu-logo.png",
    school: "Sindh Madressatul Islam University (SMIU), Karachi",
    date: "2023 - 2027",
    grade: "Current CGPA: 3 (GPA 3.1 in last semester)",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science at Sindh Madressatul Islam University (SMIU), Karachi. I have completed courses in Programming Fundamentals, Object-Oriented Programming (OOP), Data Structures, Databases (SQL and MongoDB), and Web Development (MERN Stack).",
    degree: "Bachelor of Science - BSc, Computer Science",
  },
  {
    id: 1,
    img: "collage1-logo.png",
    school: "Intermediate Board of Education, Sindh",
    date: "2021 - 2023",
    grade: "88%",
    desc: "I completed my Intermediate (Pre-Engineering) with majors in Mathematics, Physics, and Chemistry, securing 88%.",
    degree: "Intermediate - Pre-Engineering (Maths, Physics, Chemistry)",
  },
  {
    id: 2,
    img: "school-logo.png",
    school: "Secondary School Certificate (SSC)",
    date: "2019 - 2021",
    grade: "A Grade",
    desc: "I completed my matriculation with focus on Science subjects.",
    degree: "Matriculation - Science",
  },
];

export const projects = [

  {
      id: 9,
      title: "DeliveryApp",
      description:
        "Built a React.js and Redux delivery management frontend with dynamic filtering and Add to Cart functionality for smooth navigation and order management.",
      image:
        "deliveryApp.png",
      tags: [
        "React",
        "Tailwind CSS",
      ],
      category: "web api",
      url: "react-delivery-app-cfyo-nbnqr1cyt-mohits-projects-b6cc1f30.vercel.app",
      // webapp: "#",
      
    },
    {
      id: 9,
      title: "Client_Hospital_Management",
      description:
        "Developed a React.js frontend allowing users to register, log in, book appointments by department (e.g., cardiology), and send messages to the hospital, ensuring secure and user-friendly interactions.",
      image:
        "hospital.png",
      tags: [
  "React.js",
  "Node.js",
  "Express.js",
  "MongoDB",
  "Tailwind CSS",
],
      category: "web app",
      url: "mern-stack-hospital-managment-syste-eight.vercel.app/",
      webapp: "#",
    },

    {
      id: 9,
      title: "Dashboard_Hospital_Management",
      description:
        "Explore my sleek portfolio, built with HTML5, CSS3, JavaScript, and React.js. Discover my skills and projects through seamless design and interactivity, optimized for any device.",
      image:
        "dashboard.png",
      tags: [
  "React.js",
  "Node.js",
  "Express.js",
  "MongoDB",
  "Tailwind CSS",
],
      category: "web app",
      url: "dashboard-sigma-eight-58.vercel.app",
      webapp: "#",
    },

    {
      id: 9,
      title: "Ecommerce Frontend",
      description:
        "Created a responsive e-commerce template using HTML, CSS, and JavaScript, featuring product listings, search and filter layouts, and a cart interface. Designed with a modern, mobile-friendly layout as a foundation for future functionality.",
      image:
        "frontendEcommerce.png",
      tags: [
        "HTML",
        "CSS",
        "JavaScript",
      ],
      category: "web app",
      github: "frontend-ecommerce-tau-six.vercel.app",
      webapp: "#",
      
    },
];
  
  